import React, { useState, useRef, useEffect } from 'react';
import { firestore } from '../firebase/firebase';
import {
  useParams,
  useHistory,
} from 'react-router-dom';
import { Typography, Tabs, Tab, Grid } from '@material-ui/core';
import MemberOverview from './MemberOverview';
import MemberApplication from './MemberApplication';

function Member() {
  let history = useHistory();
  const isMounted = useRef(false);
  let { userId } = useParams();
  userId = useRef(userId);
  const unsubsribeFromUserDoc = useRef(null);
  const [user, setUser] = useState(null);
  const [localUser, setLocalUser] = useState({
    firstName: "",
    lastName: "",
    personalId: "",
    lmaNumber: "",
    birthDate: "",
    memberCategory: [],
    storeGroupRef: null,
    district: "",
    notes: "",
    membershipActive: false,
    hasNoPersonalId: false,
    membershipExpirationTimestamp: null,
  });
  const [storeGroups, setStoreGroups] = useState(null);
  const [tabValue, setTabValue] = useState(0);


  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (userId.current === 'ny') {
      setLocalUser({
        ...localUser,
        isNewMember: true,
        wasNewMember: true,
        physicalMemberCard: true,
      });
    } else {
      setLocalUser({
        ...localUser,
        isNewMember: false,
      })
    }
  }, [userId.current]);

  // User data.
  useEffect(() => {
    unsubsribeFromUserDoc.current && unsubsribeFromUserDoc.current();

    const aYearFromNow = new Date();
    aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1);

    if (localUser?.isNewMember === true) {
      setLocalUser({
        ...localUser,
        membershipExpirationTimestamp: aYearFromNow,
      });
    }

    else if (localUser?.isNewMember === false) {
      const userRef = firestore.doc(`users/${userId.current}`);
      unsubsribeFromUserDoc.current = userRef.onSnapshot((userSnapshot) => {
        if (userSnapshot.exists) {
          const data = userSnapshot.data();
          data.id = userSnapshot.id;

          data.membershipExpirationTimestamp = data.membershipExpirationTimestamp ?
            data.membershipExpirationTimestamp.toDate() :
            aYearFromNow;
          setUser(data);
          if (typeof localUser.id === 'undefined') {
            const submission = data.submission;
            if (typeof submission !== 'undefined' && submission !== null) {
              if (typeof submission.approvePersonalInfo === 'undefined') {
                submission.approvePersonalInfo = false;
              }
              if (typeof submission.approveSupportingDocuments === 'undefined') {
                submission.approveSupportingDocuments = false;
              }
              if (typeof submission.approveIdentity === 'undefined') {
                submission.approveIdentity = false;
              }
              if (typeof submission.feedbackFromAdmin === 'string') {
                submission.feedbackFromAdmin = ""; // Local state for feedback should start empty.
              }
              data.submission = submission;
            }
            setLocalUser({
              ...localUser,
              ...data
            });
          }
          // setMemberId(data.memberId);
        }
      });
      if (localUser?.wasNewMember) {
        history.push('/kunder/' + userId.current);
      }
    }
    return () => {
      unsubsribeFromUserDoc.current && unsubsribeFromUserDoc.current();
    };
  }, [localUser?.isNewMember]);

  // Fetch storeGroups.
  useEffect(() => {
    const getStoreGroups = async () => {
      const groups = [];
      try {
        const storeGroupsSnapShot = await firestore.collection('storeGroups').get();
        if (storeGroupsSnapShot.empty) { return; }

        storeGroupsSnapShot.forEach(group => {
          if (!group.exists) { return; }
          groups.push({
            ...group.data(),
            ref: group.ref,
          });
        });
      } catch (error) {
        console.error("Could not fetch store groups. ", error);
      }
      isMounted.current && setStoreGroups(groups);
    };
    getStoreGroups();
  }, []);



  const onCancel = async () => {
    const physicalMemberCard = typeof user.physicalMemberCard !== 'undefined'
      ? user.physicalMemberCard
      : false;
    if (!physicalMemberCard) {
      let shouldAllowPhotoEdit = user.membershipActive ? false : true;
      const userRef = firestore.doc(`users/${userId.current}`);
      await userRef.update({
        photoEditAllowed: shouldAllowPhotoEdit,
      });
    }

    history.push("/kunder/");
  };

  const handleTabChange = (event, value) => {
    setTabValue(value);
  };

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={6} md={2}>
          <Typography component="h6" variant="body2" color="primary" style={{ textAlign: "left" }}>
            Kundnummer
          </Typography>
          <Typography component="p" variant="h6" style={{ textAlign: "left" }}>
            {user?.customerId ? user.customerId : "-"}
          </Typography>
        </Grid>
        <Grid item xs={6} md={2}>
          <Typography component="h6" variant="body2" color="primary" style={{ textAlign: "left" }}>
            Medlemsnummer
          </Typography>
          <Typography component="p" variant="h6" style={{ textAlign: "left" }}>
            {user?.memberId ? user.memberId : "-"}
          </Typography>
        </Grid>
        {
          !localUser?.physicalMemberCard &&
          <Grid item xs={12} md={12}>
            <Tabs value={tabValue} onChange={handleTabChange} aria-label="Tabb-meny">
              <Tab label="Profil" />
              <Tab label="Ansökningshandlingar" />
            </Tabs>
          </Grid>
        }
      </Grid>

      {
        tabValue === 0 &&
        <MemberOverview
          userId={userId}
          user={user}
          setUser={setUser}
          localUser={localUser}
          setLocalUser={setLocalUser}
          storeGroups={storeGroups}
          onClose={onCancel}
        />
      }
      {
        tabValue === 1 &&
        <MemberApplication
          user={user}
          setUser={setUser}
          localUser={localUser}
          setLocalUser={setLocalUser}
          storeGroups={storeGroups}
        />
      }

    </React.Fragment>
  );

}

export default Member;